import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../utils/cn';
interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}
export function GlassCard({
  children,
  className,
  hover = true
}: GlassCardProps) {
  return <motion.div whileHover={hover ? {
    y: -5,
    borderColor: 'rgba(56, 189, 248, 0.3)'
  } : {}} className={cn('relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md transition-colors', className)} data-id="element-126">
      <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent pointer-events-none" data-id="element-127" />
      {children}
    </motion.div>;
}